import type { Game, GameGalleryImage } from "@/types/game";

type GameWithGalleryImages = Pick<Game, "game_image_url"> & {
  gallery_images?: GameGalleryImage[];
};

export const getOrderedGalleryImages = (game: GameWithGalleryImages) =>
  [...(game.gallery_images ?? [])].sort((a, b) => a.sort_order - b.sort_order);

export const getPrimaryGameImage = (game: GameWithGalleryImages) =>
  getOrderedGalleryImages(game)[0]?.image_url || game.game_image_url || null;

export const getSecondaryGameImage = (game: GameWithGalleryImages) =>
  getOrderedGalleryImages(game)[1]?.image_url || null;